import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    header: {
      display: 'flex',
      alignItems: 'center',
    },
    boxGroupTitle: {
      flex: 1,
    },
    wrapper: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1),
      padding: theme.spacing(3, 2),
      backgroundColor: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadiusSemiLarge,
      border: theme.shape.borderGray70,
    },
    sectionSpacing: {
      marginTop: theme.spacing(1),
    },
    loadingText: {
      color: COLORS.gray.gray40,
      padding: theme.spacing(1, 0),
    },
  }),
  { name: 'Format' }
);
